'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _View = require('./View');

var _View2 = _interopRequireDefault(_View);

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import FrontEditor from "../../App";


var TemplatesPage = (_temp = _class = function (_Page) {
  _inherits(TemplatesPage, _Page);

  function TemplatesPage() {
    _classCallCheck(this, TemplatesPage);

    return _possibleConstructorReturn(this, _Page.apply(this, arguments));
  }

  TemplatesPage.prototype.componentWillMount = function componentWillMount() {
    var templatesConnection = this.context.query.templatesConnection;
    var View = this.props.View;
    this.Renderer = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(templatesConnection))(View);
    _Page.prototype.componentWillMount && _Page.prototype.componentWillMount.call(this);
  };

  TemplatesPage.prototype.setFilters = function setFilters(filters) {
    var _context = this.context,
        uri = _context.uri,
        history = _context.router.history;
    var filtersname = "templates-filters";
    var newUri = uri.clone();

    try {
      filters = filters ? JSON.stringify(filters) : undefined;
    } catch (error) {
      console.error(error);
    }

    if (filters === "{}") {
      filters = null;
    }

    if (filters) {
      if (newUri.hasQuery) {
        var _newUri$setQuery;

        newUri = newUri.setQuery((_newUri$setQuery = {}, _newUri$setQuery[filtersname] = filters, _newUri$setQuery));
      } else {
        var _newUri$addQuery;

        newUri = newUri.addQuery((_newUri$addQuery = {}, _newUri$addQuery[filtersname] = filters, _newUri$addQuery));
      }
    } else {
      newUri.removeQuery(filtersname);
    }

    newUri.removeQuery("page");
    var url = newUri.resource();
    history.push(url);
  };

  TemplatesPage.prototype.getFilters = function getFilters() {
    var filtersname = "templates-filters";
    var uri = this.context.uri;

    var _uri$query = uri.query(true),
        filters = _uri$query[filtersname];

    try {
      filters = filters && JSON.parse(filters) || null;

      if (filters === "{}") {
        filters = undefined;
      }
    } catch (error) {
      console.error(console.error(error));
    }

    return filters;
  };

  TemplatesPage.prototype.render = function render() {
    var _this2 = this;

    var Renderer = this.Renderer;

    var _props = this.props,
        View = _props.View,
        first = _props.first,
        other = _objectWithoutProperties(_props, ['View', 'first']);

    var uri = this.context.uri;
    var where = this.getFilters();

    var _uri$query2 = uri.query(true),
        page = _uri$query2.templates_page;

    page = parseInt(page) || 0;
    var skip = page ? (page - 1) * first : 0;
    return _react2.default.createElement(Renderer, _extends({
      first: first,
      skip: skip,
      where: _extends({}, where),
      setFilters: function setFilters(filters) {
        return _this2.setFilters(filters);
      },
      getFilters: function getFilters() {
        return _this2.getFilters();
      },
      addObject: function addObject() {
        var history = _this2.context.router.history;
        history.push("/templates/create");
      }
    }, other));
  }; // render() {
  //   const {
  //     Renderer,
  //   } = this;
  //   const {
  //     View,
  //     where,
  //     ...other
  //   } = this.props;
  //   return <FrontEditor
  //     inEditMode={false}
  //     data={{
  //       object: {
  //         name: "Page",
  //         component: "Page",
  //         props: {},
  //         components: [
  //           {
  //             "name": "Connector",
  //             "props": {
  //               "first": 10,
  //               "filtersname": "filters",
  //               "orderBy": null,
  //               "query": "templatesConnection"
  //             },
  //             "components": [
  //               {
  //                 "name": "Grid",
  //                 "component": "Grid",
  //                 "props": {
  //                   "container": true,
  //                   "spacing": 8
  //                 },
  //                 "components": [
  //                   {
  //                     "name": "Grid",
  //                     "component": "Grid",
  //                     "props": {
  //                       "item": true,
  //                       "xs": 12
  //                     },
  //                     "components": [
  //                       {
  //                         "name": "Filters",
  //                         "component": "Filters",
  //                         "props": {},
  //                         "components": []
  //                       }
  //                     ]
  //                   },
  //                   {
  //                     "name": "Grid",
  //                     "component": "Grid",
  //                     "props": {
  //                       "item": true,
  //                       "xs": 12
  //                     },
  //                     "components": [
  //                       {
  //                         "name": "ListView",
  //                         "component": "ListView",
  //                         "props": {},
  //                         "components": [
  //                           {
  //                             "name": "Grid",
  //                             "component": "Grid",
  //                             "props": {
  //                               "item": true,
  //                               "xs": 12
  //                             },
  //                             "components": [
  //                               {
  //                                 "name": "Grid",
  //                                 "props": {
  //                                   "container": true,
  //                                   "spacing": 0,
  //                                   "alignItems": "flex-end"
  //                                 },
  //                                 "components": [
  //                                   {
  //                                     "name": "Grid",
  //                                     "props": {
  //                                       "spacing": 0,
  //                                       "xs": true,
  //                                       "item": true
  //                                     },
  //                                     "components": [
  //                                       {
  //                                         "name": "Link",
  //                                         "props": {
  //                                           "to": "/templates/:id"
  //                                         },
  //                                         "components": [
  //                                           {
  //                                             "name": "NamedField",
  //                                             "props": {
  //                                               "name": "name"
  //                                             },
  //                                             "components": [],
  //                                             "component": "NamedField"
  //                                           },
  //                                           {
  //                                             "name": "Tag",
  //                                             "props": {
  //                                               "tag": "span"
  //                                             },
  //                                             "components": [
  //                                               {
  //                                                 "name": "Tag",
  //                                                 "component": "Tag",
  //                                                 "props": {
  //                                                   "text": "/"
  //                                                 },
  //                                                 "components": []
  //                                               }
  //                                             ],
  //                                             "component": "Tag"
  //                                           },
  //                                           {
  //                                             "name": "NamedField",
  //                                             "props": {
  //                                               "name": "component"
  //                                             },
  //                                             "components": [],
  //                                             "component": "NamedField"
  //                                           }
  //                                         ],
  //                                         "component": "Link"
  //                                       }
  //                                     ],
  //                                     "component": "Grid"
  //                                   },
  //                                   {
  //                                     "name": "Grid",
  //                                     "props": {
  //                                       "spacing": 0,
  //                                       "item": true
  //                                     },
  //                                     "components": [
  //                                       {
  //                                         "name": "CreatedBy",
  //                                         "props": {},
  //                                         "components": [],
  //                                         "component": "CreatedBy"
  //                                       }
  //                                     ],
  //                                     "component": "Grid"
  //                                   },
  //                                   {
  //                                     "name": "Grid",
  //                                     "props": {
  //                                       "spacing": 0,
  //                                       "xs": 12,
  //                                       "item": true
  //                                     },
  //                                     "components": [
  //                                       {
  //                                         "name": "NamedField",
  //                                         "props": {
  //                                           "name": "description"
  //                                         },
  //                                         "components": [],
  //                                         "component": "NamedField"
  //                                       }
  //                                     ],
  //                                     "component": "Grid"
  //                                   },
  //                                   {
  //                                     "name": "Grid",
  //                                     "props": {
  //                                       "spacing": 0,
  //                                       "xs": 12,
  //                                       "item": true
  //                                     },
  //                                     "components": [
  //                                       {
  //                                         "name": "NamedField",
  //                                         "props": {},
  //                                         "components": [],
  //                                         "component": "NamedField"
  //                                       }
  //                                     ],
  //                                     "component": "Grid"
  //                                   }
  //                                 ],
  //                                 "component": "Grid"
  //                               }
  //                             ]
  //                           }
  //                         ]
  //                       }
  //                     ]
  //                   },
  //                   {
  //                     "name": "Grid",
  //                     "component": "Grid",
  //                     "props": {
  //                       "item": true,
  //                       "xs": 12
  //                     },
  //                     "components": [
  //                       {
  //                         "name": "Pagination",
  //                         "component": "Pagination",
  //                         "props": {},
  //                         "components": []
  //                       }
  //                     ]
  //                   }
  //                 ]
  //               }
  //             ],
  //             "component": "Connector"
  //           },
  //         ],
  //       },
  //     }}
  //   />
  // }


  return TemplatesPage;
}(_layout2.default), _class.propTypes = {
  View: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
  View: _View2.default,
  first: 10
}, _temp);
exports.default = TemplatesPage;
module.exports = exports['default'];